import { useOpQuery } from './useOpQuery';

export const useBasePackagePlan = (orgId: number) => {
  const { data: orgPackagePlansSelected, isLoading } = useOpQuery({
    apiEndpointName: 'listOrgPackagePlansSelected',
    parameters: [orgId],
    select: (heliumResponse) => heliumResponse.json.data,
  });

  const basePackagePlan = orgPackagePlansSelected?.find(
    (orgPackagePlan) =>
      orgPackagePlan?.packagePlan?.package?.parentPackages?.length === 0,
  );

  return { basePackagePlan, isLoading };
};
